import React from "react";
import { Link } from "react-router-dom";

const footer = () => {
	return (
		<div className='mt-12 pb-2 text-center'>
			<p className='text-center text-primary'>
				<Link to='privacy-policy'>Privacy Policy</Link> |{" "}
				<Link to='terms-of-use'>Terms of use</Link>
			</p>
		</div>
	);
};

export default footer;
